<template>
  <div>
    <div>
      <span style="color:#000000; font-weight: 900; font-size: 18px; margin-right: 8px;">選擇寵物</span>
      <span style="font-size:16px; color:#F74747">最多可入住數: {{ currentMaxAccommodates || '' }}</span>
    </div>
    <div style="padding:20px;padding-right:36px;display: flex;flex-direction: column;gap:18px">
      <div
        v-for="(pet, index) in info"
        style="
        background-color: #ffffff; border: solid 1px #E5E7EB;
        border-radius: 8px; height:100px; display: flex;
        align-items: center; justify-content:space-between; padding: 8px 12px;"
        :key="index"
        :class="{
          'ineligible-cell': isIneligible(pet), // 優先級最高：資格不符
          'selected-cell': isSelected(pet),
          'full-disabled-cell': !isIneligible(pet) && isFull(index), // 其次：人數額滿
        }"
        :style="{ cursor: isIneligible(pet) || isFull(index) ? 'default' : 'pointer' }"
        @click="!isIneligible(pet) && !isFull(index) && toggleCell(index, pet)"
      >
        <div style="display:flex;">
          <el-image :src="pet.avatar ? pet.avatar : require('@assets/images/staff_avatar_haku.png')" style="width: 75px; height: 75px; border-radius: 50%;margin-right:18px" fit="fit" />

          <div style="margin-left: 16px; display: flex; flex-direction: column; justify-content: center;align-items:flex-start; height: 84px; color:#6C6B6B">
            <div>
              <span style="font-weight:900;color:#000000">{{ pet.name || '' }}</span>
            </div>
            <div>
              <span style="margin-right: 6px;">{{ pet.category.tags[0] || '' }}</span>
              <span class="category-label">{{ pet.category.title || '' }}</span>
            </div>
            <div style="display: flex; align-items: center;">
              <div
                style="width:12px; height: 12px; border-radius: 50%; margin-right: 8px;"
                :style="{
                  backgroundColor: pet.isEvaluationRequired ? '#F74747' : '#5FC956',
                }"
              />
              <span :style="{ color: pet.isEvaluationRequired ? '#F74747' : '#5FC956' }">
                {{ pet.isEvaluationRequired ? '需評估' : '不需評估' }}
              </span>
            </div>
          </div>
        </div>
        <div class="eye-icon-container"><i class="el-icon-view" @click.stop="handleEyeClick(pet)" style="margin-left: 4px;color: #EA6A2A; font-size:28px;font-weight: 600; cursor: pointer;"/></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectPetListPartial',
  components: {},
  props: {
    info: {
      type: Array,
      required: true,
      default: () => [],
    },
    eligiblePets: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentMaxAccommodates: {
      type: Number,
      required: true,
      default: 1,
    },
    availableCategoryIds: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedPets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {
    isSelected() {
      return (pet) => {
        return this.selectedPets.some((item) => item.id === pet.id)
      }
    },
    isIneligible() {
      return (pet) => {
        if (!this.availableCategoryIds || !pet?.category?.id) return false
        return !this.availableCategoryIds.includes(pet.category.id)
      }
    },
    isFull() {
      return (index) => {
        return this.selectedPets.length >= this.currentMaxAccommodates && !this.selectedPets.some((p) => p.id === this.info[index].id)
      }
    },
  },
  methods: {
    toggleCell(index, pet) {
      // 規則 A：如果資格不符 (類別不在允許名單內)，直接阻斷
      if (!this.availableCategoryIds.includes(pet.category.id) || this.isIneligible(pet)) {
        return
      }

      // 1. 檢查這隻寵物「是不是已經被選了」
      // 我們改用 id 來找，這比 index 更安全
      const isSelected = this.selectedPets.some((p) => p.id === pet.id)

      if (isSelected) {
        // 規則 B：如果已經選了，那就取消 (過濾掉這隻 ID)
        const newList = this.selectedPets.filter((p) => p.id !== pet.id)

        // 通知父組件同步到 Vuex
        this.$emit('update:selectedPets', newList)
      } else {
        // 規則 C：如果沒選過，先檢查「人數是否已滿」
        // 使用 isFull(index) 判斷
        if (!this.isFull(index)) {
          // 沒滿，就把它加入清單
          const newList = [...this.selectedPets, pet]

          // 通知父組件同步到 Vuex
          this.$emit('update:selectedPets', newList)
        } else {
          // 如果滿了，通常可以在這裡做個提示
          this.$message.warning('已達最高入住數，不能再選了')
        }
      }

      console.log('最新的選取清單已送出:', this.selectedPets)
    },
    handleEyeClick(pet) {
      this.$emit('view-pet', pet)
    },
  },
}
</script>

<style lang="scss" scoped>
.ineligible-cell {
  background-color: #f5f5f5 !important;
  border-color: #dcdfe6 !important;
  filter: grayscale(100%);
  opacity: 0.6;

  /* 讓主體點擊失效，但眼睛圖示容器除外 */
  & > *:not(.eye-icon-container) {
    pointer-events: none;
  }

  /* 眼睛圖示容器不受灰階影響，保持橘色 */
  .eye-icon-container {
    filter: grayscale(0%) !important;
    opacity: 1 !important;
    pointer-events: auto !important;
  }
}

.full-disabled-cell {
  opacity: 0.7;
  cursor: not-allowed;
}

.selected-cell {
  box-shadow: 0 0 0 1px #ea6a2a inset;
  border-color: #ea6a2a !important;
  background-color: #fdf0e9 !important;
  border-radius: 8px;
}

.category-label {
  display: inline-block;
  color: #606266; /* 灰黑色 */
  /* 如果標題太長，顯示省略號 (...) */
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>
